<template>
    <div>

        <div class="v-click-modal" :class="{'v-click-modal--hover': hover}"
             @mouseenter="hover = true"
             @mouseleave="hover = false"
             @click="show = true">
            <div class="v-click-modal__label">
                {{ label }}
            </div>
        </div>

        <v-modal :show="show" @close="show=false">
            <div class="v-click-modal__content">
                <h3 class="v-click-modal__heading">{{ heading }}</h3>
                <div class="v-click-modal__items">
                    <template v-for="text in items">
                        <div class="v-click-modal__item">
                            <i-check class="v-click-modal__check"></i-check>
                            <div class="v-click-modal__text">
                                {{ text }}
                            </div>
                        </div>
                    </template>
                </div>
                <div class="v-click-modal__annotations">
                    <template v-for="annotation in annotations">
                        <div class="v-click-modal__annotation">
                            <div class="v-click-modal__text">
                                {{ annotation }}
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </v-modal>
    </div>
</template>

<script>
    import iCheck from "./icons/check"
    import vModal from "./vModal"

    export default {
        name: "EdaDetails",
        components: {
            iCheck,
            vModal
        },
        data: function () {
            return {
                hover: false,
                show: false
            }
        },
        methods: {
            showBubble: function () {
                this.show = true;
            },

            hideBubble: function () {
                this.show = false;
            }
        },
        props: {
            heading: {default: Text, default: ""},
            label: {default: Text, default: ""},
            items: {
                type: Array, default: function () {
                    return []
                }
            },
            annotations: {
                type: Array, default: function () {
                    return []
                }
            }
        },
        created(){

        }
    }
</script>

<style lang="scss">

    //noinspection CssUnknownTarget
    @import '~@/scss/main.scss';

    .v-click-modal {
        color: $dark-color;
        font-size: 1em;
        text-align: left;
        width: 100%;
        position: relative;

        &__label {
            cursor: pointer;
            text-align: center;
            color: $dim-color;
        }

        &__check {
            margin-top: 0.25em;
            width: 1.25em;
            height: 1.25em;
            margin-right: 1em;
            flex: none;
        }

        &__item {
            display: flex;
            padding: 0.5em 0;
            text-align: left;
        }


        &__annotation {
            padding: 0.5em 0;
            text-align: left;
            font-size: .95em;
        }

        &__heading {
            text-align: left;
            font-size: 1.2em;
            font-weight: 500;
            padding-bottom: 1em;
        }

        &--hover {
            .v-click-modal {

                &__label {
                    color: $primary-color;
                }

            }

        }
    }


</style>